@if (loading && !loaded) {
    <div class="status"><mat-spinner diameter="24"></mat-spinner><span>Loading your to do list&hellip;</span></div>
}@else if (error) {
    <div class="status error">
        <mat-icon>error_outline</mat-icon>
        <span>{{error}}</span>
        <button mat-button color="accent" (click)="loadData()" [disabled]="loading">Try again</button>
    </div>
}@else if (data.length === 0) {
    <p class="empty">Nothing to do. Add a To do item to a model from the Notes section of the palette, and assign it to people to have it appear on their list.</p>
}@else {
    <p class="summary">Items assigned to you in models you can open. Select one to go to it in its model.</p>
    <app-table [columns]="columns" [data]="data" [rowSelect]="true" (rowEvent)="handleRowEvent($event)"></app-table>
}
